// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"2eff9042","453":"378c521b","499":"73da5c8e","510":"a48f723e","547":"a2e44a94"}[chunkId] + ".chunk.js";
};